<form [formGroup]="form">
  <spb-yes-no-radio
    [externalControl]="form.controls.have"
    leadText="{{'Har ' + ('du/ni' | plr | async) + ' barn?'}}"
  ></spb-yes-no-radio>
</form>